<template>
	<div class="ContingentDateField">
		<v-label class="field-label">{{ $t('text.date') }}</v-label>
		<v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition">
			<template #activator="{ props }">
				<v-text-field v-bind="props" :model-value="formattedDate" readonly variant="outlined" density="compact"
					hide-details append-inner-icon="mdi-menu-down" :placeholder="$t('text.chooseDate')" data-cy="dateField" />
			</template>
			<RebookingContingentCalendar
				:model-value="modelValue"
				:time="time"
				:days="days"
				:min-date="minDate"
				:max-date="maxDate"
				:loading="loading"
				@update:model-value="onSelect"
				@update:month="$emit('update:month', $event)"
			/>
		</v-menu>
	</div>
</template>

<script>
import RebookingContingentCalendar from './RebookingContingentCalendar.vue'
import { formatDateTime } from './rebooking-utils'

export default {
	name: 'ContingentDateField',
	components: { RebookingContingentCalendar },
	props: {
		modelValue: String, // YYYY-MM-DD
		time: String, // selected timeslot HH:mm — the calendar shows that slot's contingent
		days: Object,
		minDate: String,
		maxDate: String,
		loading: Boolean,
	},
	data: () => ({
		menu: false,
	}),
	computed: {
		formattedDate() {
			return formatDateTime(this.modelValue)
		},
	},
	methods: {
		onSelect(date) {
			this.$emit('update:modelValue', date)
			this.menu = false
		},
	},
}
</script>

<style scoped>
.field-label { font-size: 13px; margin-bottom: 4px; display: block; }
</style>
